<template lang='pug'>
Input(:commit='doCommit' :theValue='theValue.toString()')
  input(class='form-control' :value='theValue' :size='size')
</template>

<script>
import Input from './Input'

export default {
  components: { Input },

  props: {
    theValue: Number,
    commit: Function,
    size: {
      type: Number,
      default: 20
    }
  },

  methods: {
    async doCommit(rawValue) {
      const value = Number.parseFloat(rawValue)
      await this.commit(isNaN(value) ? this.theValue : value)
    }
  }
}
</script>
